/** @jsx isolateComponent */

import { isolateComponent } from '@zapier/style-encapsulation';
import { Colors, Button, Typography, Spacer } from '@zapier/design-system';

import Surface from '@zapier/product-get-help/src/components/shared/Surface';

import Fields, { Field } from './FormFields/Fields';
import { useFilterFields } from './hooks/useFilterFields';

const RebrandStyles = {
  additionalInfo: {
    ...Typography.paragraph3,
    color: Colors.neutral800,
    marginTop: '0px',
    marginBottom: '20px',
  },
  buttonWrapper: {
    marginTop: '40px',
    display: 'flex',
    justifyContent: 'flex-end',
  },
};

export type FormState = 'initial' | 'readyToSubmit' | 'submitting';

type EmailStepProps = {
  /** An array of fields to render in the form. */
  fields: Array<Field>;
  /** What state the form is in.  */
  formState: FormState;
  /** Whether the user can see and select the Critical Issue checkbox */
  isCriticalTicketEligible: boolean;
};

/**
 * Renders a form with fields and a submit button.
 */
const EmailStep = ({
  fields,
  formState,
  isCriticalTicketEligible,
}: EmailStepProps) => {
  const filteredFields = useFilterFields({
    fields,
    isCriticalTicketEligible,
  });

  return (
    <Surface title="Tell us about your issue">
      <div css={RebrandStyles.additionalInfo}>
        Please note the apps you are using and what you are hoping to
        accomplish. If you have an example that illustrates your question,
        please provide that as well.
      </div>
      <Spacer height={10} />
      <Fields fields={filteredFields} />
      <Spacer height={10} />
      <div css={RebrandStyles.buttonWrapper}>
        <Button disabled={formState !== 'readyToSubmit'} type="submit">
          {formState === 'submitting' ? 'Sending...' : 'Send'}
        </Button>
      </div>
    </Surface>
  );
};

export default EmailStep;
